import {
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  UseDisclosureReturn
} from "@chakra-ui/react"
import { useEffect } from "react"
import AugmentationToolbar, {
  AugmentationToolbarHookReturn
} from "./AugmentationToolbar"

type AugmentationToolbarPopoverProps = {
  toolbar: AugmentationToolbarHookReturn
  disclosure: UseDisclosureReturn
  children: React.ReactNode
}

function AugmentationToolbarPopover({
  toolbar,
  disclosure,
  children
}: AugmentationToolbarPopoverProps) {
  // When you close the augmentaiton, the toolbar is no longer selected,
  // but the popover is still open. TODO: avoid the flash of the detailed
  // view during the transition from selected to unselected state.
  useEffect(() => {
    if (!toolbar.selectedKey) disclosure.onClose()
  }, [toolbar.selectedKey])

  return (
    <Popover
      {...disclosure}
      placement="bottom-end"
      closeOnBlur={!toolbar.selectedKey}
      // Lazy props for ensuring toolbar animations execute properly.
      isLazy
      lazyBehavior="unmount"
    >
      <PopoverTrigger>{children}</PopoverTrigger>
      <PopoverContent
        width="auto"
        bg="transparent"
        boxShadow="none"
        border="none"
        p={0}
      >
        {/* <PopoverHeader></PopoverHeader> */}
        <PopoverBody p={0}>
          <AugmentationToolbar
            toolbar={toolbar}
            detailed={!toolbar.selectedKey}
            direction="column"
            alwaysVisible
          />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}

export default AugmentationToolbarPopover
